import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { Http } from "../../../../helpers/Http";
import { useLocation, useOutletContext } from "react-router-dom";

const MantMetodoPago = ({MySwal, mant, idEdit, createData, updateData, closeSection, idRef, setIdRef, endPointShow, setEndPointUpdate, showCreate, showEdit}) => {
    const location = useLocation();
    const { showSpinnerLoader } = useOutletContext();

    const { register, handleSubmit, reset, getValues, setValue, formState: { errors } } = useForm({mode: "onChange"});
    const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    const [valueAplicadoA, setValueAplicadoA] = useState(CONFIGURACIONES.INIT.NULL);
    const [valueTipo, setValueTipo] = useState(CONFIGURACIONES.INIT.STRING);

    const [valueTipoDisabled, setValueTipoDisabled] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [objCuentaContable, setObjCuentaContable] = useState(CONFIGURACIONES.INIT.NULL);

    useEffect(() => {
        reset();
        showSpinnerLoader();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSeg', lastSegment);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            setIdRef((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            showData((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            setTitle((lastSegment === 'new')? `Creando ${mant}`:`Editando ${mant}`);
        }
    }, [location.pathname]);

    const onSubmit1 = (form) => {
        if (!objCuentaContable) {  
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `<small>Por favor indique <strong class="text-danger">CUENTA CONTABLE</strong> válida.</small>`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });
            return; 
        }
        
        let data = {
            'aplicadoA': form.aplicadoA,
            'nombre': form.nombre,
            'idInterno': form.idInterno,
            'valorLabel': form.valorLabel,
            'referencia': form.referencia,
            'formaPago': form.formaPago,
            'tipo': valueTipo,
            'consideraEntidadBancaria': form.consideraEntidadBancaria,
            'validacionInput': form.validacionInput,
            'cuentaContableId': objCuentaContable.id,
            'cuentaContableCodigo': objCuentaContable.codigo,
            'cuentaContableNombre': objCuentaContable.nombre
        }
        // console.log('form', form);
        if (idRef === CONFIGURACIONES.INIT.ID_EDIT) {
            createData(data);
        } else {
            updateData(data);
        }
    };

    const showData = async (ref) => {
        console.log('ref', ref);
        
        if (ref !== CONFIGURACIONES.INIT.ID_EDIT) {
            console.log('entras...', endPointShow);
            if (endPointShow === CONFIGURACIONES.INIT.STRING || !showEdit) { closeSection(); }
            
            await Http().get(endPointShow)
            .then(async (rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    // setLinks(rpta.data.links);
                    setEndPointUpdate(rpta.data.links.find(link => link.rel === CONFIGURACIONES.REFS.UPDATE)?.href || null);
                    // let cmpLink = rpta.data.links.find(link => link.rel === CONFIGURACIONES.INIT.HREF_LOGS);
                    // console.log('cmpLink', cmpLink);
                    // await loadLogData(cmpLink?.href);
                    loadForm(rpta.data);
                }
            });
        } else {
            if (!showCreate) { closeSection(); }
        }
    };

    const fnBuscarCuentaContable = () => {
        let cuenta = getValues('cuentaContable');
        let data = {
            body: {
                'cuenta': cuenta
            }
        };

        // setValue('codigoCuentaContable', CONFIGURACIONES.INIT.STRING);
        setValue('nombreCuentaContable', CONFIGURACIONES.INIT.STRING);
        setObjCuentaContable(CONFIGURACIONES.INIT.NULL);

        Http().post(`${CONFIGURACIONES.ENDPOINTS.CUENTAS_CONTABLE}/buscar-cuenta`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                if (rpta.data.cuenta !== CONFIGURACIONES.INIT.NULL) {
                    setObjCuentaContable(rpta.data.cuenta);
                    // setValue('codigoCuentaContable', rpta.data.cuenta.codigo);
                    setValue('nombreCuentaContable', `${rpta.data.cuenta.codigo} - ${rpta.data.cuenta.nombre}`);
                } else {
                    MySwal.fire({
                        title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                        html: `<small class="text-danger">No se obtuvo resultados, registre por favor.</small>`,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        cancelButtonColor: "#f62d51",
                        confirmButtonColor: "#2962FF"
                    });
                }
            }
        });
    };

    const loadForm = (object) => {
        setValue('aplicadoA', object.aplicadoA);
        setValue('nombre', object.nombre);
        setValue('idInterno', object.idInterno);
        setValue('referencia', object.referencia);
        setValue('tipo', object.tipo);
        setValue('formaPago', object.formaPago);
        setValue('valorLabel', object.valorLabel);
        setValue('validacionInput', object.validacionInput);
        setValue('consideraEntidadBancaria', (object.consideraEntidadBancaria === CONFIGURACIONES.INIT.STRING_SI?CONFIGURACIONES.INIT.STATUS_TRUE:CONFIGURACIONES.INIT.STATUS_FALSE));
        setValue('cuentaContable', object.cuentaContableCodigo);
        setValue('nombreCuentaContable', `${object.cuentaContableCodigo} - ${object.cuentaContableNombre}`)
        
        
        setValueAplicadoA(object.aplicadoA);
        setValueTipo(object.tipo);
        setObjCuentaContable(CONFIGURACIONES.INIT.NULL);
        if (object.cuentaContableId !== CONFIGURACIONES.INIT.STRING) {
            setObjCuentaContable({
                'id': object.cuentaContableId,
                'codigo': object.cuentaContableCodigo,
                'nombre': object.cuentaContableNombre
            })
        }

        setValueTipoDisabled(CONFIGURACIONES.INIT.STATUS_FALSE);
        if (object.aplicadoA !== CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.GENERAL) {
            setValueTipoDisabled(CONFIGURACIONES.INIT.STATUS_TRUE);
        }
    };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold">{title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="aplicadoA" className="control-label col-form-label">Aplicado a <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("aplicadoA", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    let value = e.target.value;
                                                    setValueAplicadoA(value);
                                                    setValue('tipo', '');
                                                    setValueTipo(CONFIGURACIONES.INIT.STRING);
                                                    setValueTipoDisabled(CONFIGURACIONES.INIT.STATUS_FALSE);
                                               
                                                    if (value !== CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.GENERAL) {
                                                        setValueTipoDisabled(CONFIGURACIONES.INIT.STATUS_TRUE);
                                                    }

                                                    if (value === CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.DESEMBOLSO_CREDITO) {
                                                        setValue('tipo', 'E');
                                                        setValueTipo('E');
                                                    } else if (value === CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.COBRO_CREDITO) {
                                                        setValue('tipo', 'I');
                                                        setValueTipo('I')
                                                    }
                                                }
                                            })} className="form-control" id="aplicadoA" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                CONFIGURACIONES.INIT.LIST.APLICADO_A_METODOS_PAGO.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.aplicadoA && errors.aplicadoA.message }</small>           
                                    </div>
                                </div>
                                
                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="nombre" className="control-label col-form-label">Nombre <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("nombre", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="nombre" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombre && errors.nombre.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="idInterno" className="control-label col-form-label">ID Interno <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("idInterno", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.ID_INTERNO_50,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="idInterno" placeholder="" maxLength={50} />
                                        <small className="invalid-feedback"> { errors.idInterno && errors.idInterno.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="formaPago" className="control-label col-form-label">Forma de Pago <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("formaPago", {
                                                required: OWASP.REQUIRED
                                            })} className="form-control" id="formaPago" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                CONFIGURACIONES.INIT.LIST.FORMAS_PAGO.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.formaPago && errors.formaPago.message }</small>           
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipo" className="control-label col-form-label">Tipo de Movimiento <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipo", {
                                                required: OWASP.REQUIRED,
                                                disabled: valueTipoDisabled,
                                                onChange: (e) => {
                                                    setValueTipo(e.target.value);
                                                }
                                            })} className="form-control" id="tipo" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                CONFIGURACIONES.INIT.LIST.TIPOS_MOVIMIENTO_CAJA.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipo && errors.tipo.message }</small>           
                                    </div>
                                </div>

                                {valueAplicadoA !== CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.DESEMBOLSO_CREDITO && <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="referencia" className="control-label col-form-label">Referencia <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("referencia", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="referencia" placeholder="" />
                                        <small className="invalid-feedback"> { errors.referencia && errors.referencia.message }</small>           
                                    </div>
                                </div>}

                                {valueAplicadoA === CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.DESEMBOLSO_CREDITO && <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="valorLabel" className="control-label col-form-label">Valor de Label <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("valorLabel", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="valorLabel" placeholder="" />
                                        <small className="invalid-feedback"> { errors.valorLabel && errors.valorLabel.message }</small>           
                                    </div>
                                </div>}

                                {valueAplicadoA === CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.DESEMBOLSO_CREDITO && <div className="col-sm-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="validacionInput" className="control-label col-form-label">Validación del Input <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("validacionInput", {
                                                required: OWASP.REQUIRED,
                                            })}
                                            type="text" className="form-control" id="validacionInput" placeholder="" />
                                        <small className="invalid-feedback"> { errors.validacionInput && errors.validacionInput.message }</small>           
                                    </div>
                                </div>}
                            </div>
                            
                            {valueAplicadoA === CONFIGURACIONES.INIT.LIST_APLICADO_A_METODOS_PAGO.DESEMBOLSO_CREDITO && <div className="row">
                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id="chkConsideraEntidadBancaria" {...register('consideraEntidadBancaria')} />
                                            <label className="custom-control-label" htmlFor="chkConsideraEntidadBancaria">Considera Entidad Bancaria</label>
                                        </div>
                                        <small className="invalid-feedback"> { errors.consideraEntidadBancaria && errors.consideraEntidadBancaria.message }</small>           
                                    </div>
                                </div>
                            </div>}

                            <hr className="bg-success pb-1" />
                            <div className="row">
                                <div className="col-sm-12">        
                                    <h5 className="text-muted">Para Contabilidad</h5>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="cuentaContable" className="control-label col-form-label">Cuenta Contable <span className="text-danger">*</span></label>
                                        <div className="input-group">
                                            <input {...register("cuentaContable", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            type="text" className="form-control" id="cuentaContable" placeholder="" />
                                       

                                            <div className="input-group-append">
                                                <WaveButton type="button" className="btn btn-sm btn-success" onClick={fnBuscarCuentaContable}>
                                                    <i className="mdi mdi-magnify"></i>
                                                </WaveButton>
                                            </div>
                                        </div>

                                        <small className="invalid-feedback"> { errors.cuentaContable && errors.cuentaContable.message } </small>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="nombreCuentaContable" className="control-label col-form-label">Nombre de Cuenta <span className="text-danger">*</span></label>
                                        <input {...register("nombreCuentaContable", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                },
                                                disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                            })} type="text" className="form-control" id="nombreCuentaContable" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombreCuentaContable && errors.nombreCuentaContable.message } </small>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                       
                    <div className="action-form mt-1 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantMetodoPago;